<style lang="scss">
.top-status{
  text-align: center;
  color:#fff;
  padding:30px 0;
  font-size: 14px;
  font-weight: bold;
  background: url("../assets/images/mobile/bg_primary.png") no-repeat;
  background-size: 100% 100%;
  &.bg-red{
    background: url("../assets/images/mobile/bg_red.png") no-repeat;
    background-size: 100% 100%;
  }
}
.status-icon{
  img{
    height:26px;
  }
}
</style>
<template>
  <div class="top-status" :class="{'bg-red' : status === 'WAIT' || status === 'PART_SEND'}">
    <div class="status-icon">
      <img src="@/assets/images/mobile/icon_ing.png" v-if="status === 'ING'"/>
      <img src="@/assets/images/mobile/icon_wait.png" v-if="status === 'WAIT' || status === 'NEED_AUDITING'"/>
      <img src="@/assets/images/mobile/icon_ok.png" v-if="status === 'OK' || status === 'FINISHED'"/>
      <img src="@/assets/images/mobile/icon_lock.png" v-if="status === 'PART_SEND' || status === 'NEED_SEND'"/>
    </div>
    订单状态：{{statusName}}
  </div>
</template>

<script>
export default {
  name: 'qk-status-icon',
  props: {
    status: {
      type: String
    },
    statusName: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/statusIcon.vue